import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";
import { ApplicationFormSchema } from "components/templates/AddApplicationFormGroupModal/ApplicationForm";

const fetchByType = (courseId: number, type: number): AxiosPromise<CourseFormApi[]> => {
  return api.get<CourseFormApi[]>(endpoints.COURSEFORM.GET_BY_TYPE(courseId, type));
};

const fetchFields = (courseId: number, formId: number): AxiosPromise<CourseFormFieldApi[]> => {
  return api.get<CourseFormFieldApi[]>(endpoints.COURSEFORM.GET_FIELDS(courseId, formId));
};

const addField = (
  courseId: number,
  formId: number,
  courseFormGroupId: number,
  body: ApplicationFormSchema,
): AxiosPromise<CourseFormFieldApi> => {
  return api.post<CourseFormFieldApi>(endpoints.COURSEFORM.ADD_FIELD(courseId, formId, courseFormGroupId), body);
};

const updateField = (
  courseId: number,
  formId: number,
  courseFormGroupId: number,
  courseFormFieldId: number,
  body: ApplicationFormSchema,
): AxiosPromise<CourseFormFieldApi> => {
  return api.put<CourseFormFieldApi>(
    endpoints.COURSEFORM.UPDATE_FIELD(courseId, formId, courseFormGroupId, courseFormFieldId),
    body,
  );
};

const addGroup = (courseId: number, formId: number, body: ApplicationFormSchema): AxiosPromise<CourseFormFieldApi> => {
  return api.post<CourseFormFieldApi>(endpoints.COURSEFORM.ADD_GROUP(courseId, formId), body);
};

const getAll = (isTemplate?: boolean): AxiosPromise<CourseFromGroupApi[]> => {
  return api.get<CourseFromGroupApi[]>(endpoints.COURSEFORM.GET_ALL(isTemplate));
};

const updateGroup = (
  courseId: number,
  formId: number,
  courseFormGroupId: number,
  body: ApplicationFormSchema,
): AxiosPromise<CourseFormFieldApi> => {
  return api.put<CourseFormFieldApi>(endpoints.COURSEFORM.UPDATE_GROUP(courseId, formId, courseFormGroupId), body);
};

const copyGroup = (courseId: number, formId: number, copyCourseFormGroupId: number): AxiosPromise<number> => {
  return api.post<number>(endpoints.COURSEFORM.COPY_GROUP(courseId, formId, copyCourseFormGroupId));
};

const deleteField = (
  courseId: number,
  formId: number,
  courseFormGroupId: number,
  courseFormFieldId: number,
): AxiosPromise<CourseFormFieldApi> => {
  return api.delete(endpoints.COURSEFORM.DELETE_FIELD(courseId, formId, courseFormGroupId, courseFormFieldId));
};

const deleteGroup = (courseId: number, formId: number, courseFormGroupId: number): AxiosPromise<CourseFormFieldApi> => {
  return api.delete(endpoints.COURSEFORM.DELETE_GROUP(courseId, formId, courseFormGroupId));
};

export const courseformsApi = {
  fetchByType,
  addField,
  fetchFields,
  addGroup,
  copyGroup,
  getAll,
  updateGroup,
  updateField,
  deleteField,
  deleteGroup,
};

export interface CourseFormApi {
  id: number;
  type: number;
  groups: CourseFromGroupApi[];
}

export interface CourseFromGroupApi {
  courseFormGroupId: number;
  name: string;
  description: string;
  isTemplate: boolean;
  isFromCategory?: boolean;
  fields: CourseFormFieldApi[];
}
export interface CourseFormFieldApi {
  id: number;
  name: string;
  description: string;
  fieldType: number;
  dictionaryId?: number;
  isRequired: boolean;
  conditions: {
    fieldId: number;
    condition: number;
    conditionValue: string;
    fieldType: number;
  }[];
}
